import { useState, useEffect, useMemo } from "react";
import { useTenant } from "../../../../hooks/useTenant";
import SessionService from "../../../../services/session_service";
import moment from "moment";
import { toast } from "react-toastify";

export const useTVDisplay = () => {
    const { idTenant, tenantLogo } = useTenant();
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentTime, setCurrentTime] = useState(moment());

    // 1. Fetch sessions for today
    useEffect(() => {
        let isMounted = true;

        const fetchTodaySessions = async () => {
            if (!idTenant) return;
            
            setLoading(true);
            try {
                const todayStr = moment().format("YYYY-MM-DD");
                // Fetch using existing service
                const dailySessions = await SessionService.getSessions(idTenant, todayStr, todayStr);
                
                if (isMounted) {
                    setSessions(dailySessions || []);
                }
            } catch (error) {
                console.error("Erro ao buscar sessões para a TV:", error);
                if (isMounted) toast.error("Não foi possível carregar a agenda do dia.");
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        fetchTodaySessions();

        // Refetch fully every hour to keep things fresh just in case (e.g. crossing midnight)
        const hourlyInterval = setInterval(fetchTodaySessions, 60 * 60 * 1000);
        
        return () => {
            isMounted = false;
            clearInterval(hourlyInterval);
        };
    }, [idTenant]);

    // 2. Keep current time ticking every minute
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(moment());
        }, 1000 * 60); // Updates every minute
        
        return () => clearInterval(timer);
    }, []);

    // 3. Derived State: classes to show
    const currentSessions = useMemo(() => {
        const nowStr = currentTime.format("HH:mm");
        const DURATION_MARGIN_MINUTES = 0; // Só mostra exatamente a partir do horário de início

        return sessions.filter(session => {
            // Se não tem startTime ou endTime, descarta
            if (!session.startTime || !session.endTime) return false;
            
            // Verifica se a classe está rolando ou começará em breve
            const startMoment = moment(session.startTime, "HH:mm").subtract(DURATION_MARGIN_MINUTES, 'minutes');
            const endMoment = moment(session.endTime, "HH:mm");
            
            const currentMoment = moment(nowStr, "HH:mm");

            return currentMoment.isBetween(startMoment, endMoment, null, '[]');
        }).sort((a, b) => a.startTime.localeCompare(b.startTime));

    }, [sessions, currentTime]);

    return {
        currentTime,
        currentSessions,
        loading,
        tenantLogo
    };
};
